// Offline games remain available for testing, but are blocked on production.
export const isOfflineFeatureEnabled = (env, hostname = "") => {
 const api = String(env.VITE_APP_BASE_URL || "").replace(/\/+$/, "");
 return env.VITE_APP_OFFLINE_GAMES_ENABLED !== "false"
  && api !== "https://portal-api.akedo.gg"
  && !/^(www\.)?akedo\.gg$/i.test(hostname);
};
